import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Rothko from "web/script/modules/rothko";
import _escape from "lodash/escape";
import { gettext } from "web/script/modules/django-i18n";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import { ShippingOptionPropType } from "web/types/buy-option";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import LeadLink from "web/react/components/lead-link/lead-link";
import style from "./shipping.css";

function Shipping(_ref) {
  var className = _ref.className,
      expressShipping = _ref.expressShipping,
      freeReturn = _ref.freeReturn,
      freeShipping = _ref.freeShipping,
      freeShippingUrl = _ref.freeShippingUrl,
      leadUrl = _ref.leadUrl,
      retailerName = _ref.retailerName,
      linkId = _ref.linkId;
  var seeMoreOnSpanProps = {
    class: style.seeMoreOn
  };
  var seeMoreOnRetailerSpanProps = {
    class: style.link
  }; // we escape retailerName, and so mark this string as available for dangerouslySetInnerHTML

  var seeMoreOnRetailerSafeHtml = {
    __html: gettext("in_stock_product.see_more_on_retailer.in_spans", {
      see_more_span_props: getHtmlProps(seeMoreOnSpanProps),
      retailer_name_span_props: getHtmlProps(seeMoreOnRetailerSpanProps),
      retailer_name: _escape(retailerName)
    })
  };

  var _useState = useState({
    data: {}
  }),
      _useState2 = _slicedToArray(_useState, 2),
      extraShipping = _useState2[0],
      setExtraShipping = _useState2[1];

  useEffect(function () {
    if (linkId) {
      var options = {
        link_id: linkId
      };
      Rothko.fetch("modules/overlays/shipping_and_returns_overlay", options).then(function (res) {
        return setExtraShipping(res);
      }).catch(function () {});
    }
  });
  return React.createElement("div", {
    className: classnames(className, style.wrapper)
  }, freeShipping && React.createElement("div", {
    className: style.freeShipping
  }, React.createElement("div", {
    className: style.icon
  }, React.createElement(SVGIcon, {
    name: "truck"
  })), freeShippingUrl ? React.createElement("a", {
    className: style.shippingLabel,
    href: freeShippingUrl,
    dangerouslySetInnerHTML: {
      __html: freeShipping.html_message
    }
  }) : React.createElement("span", {
    className: style.shippingLabel,
    dangerouslySetInnerHTML: {
      __html: freeShipping.html_message
    }
  })), expressShipping && React.createElement("div", {
    className: style.expressShipping
  }, React.createElement("div", {
    className: style.icon
  }, React.createElement(SVGIcon, {
    name: "stopwatch"
  })), React.createElement("span", {
    className: style.shippingLabel
  }, gettext("in_stock_product.express_shipping_label"))), freeReturn && React.createElement("div", {
    className: style.freeReturn
  }, React.createElement("div", {
    className: style.icon
  }, React.createElement(SVGIcon, {
    name: "tick-new"
  })), React.createElement("span", {
    className: style.shippingLabel
  }, gettext("in_stock_product.free_returns_label"))), extraShipping.shipping_options && React.createElement("section", null, React.createElement("p", null, gettext("in_stock_product.shipping_by_retailer", {
    retailer_name: extraShipping.retailer_name
  })), extraShipping.shipping_options.map(function (option, i) {
    return React.createElement("div", {
      key: i,
      className: style.option
    }, React.createElement("div", {
      className: style.optionPrice
    }, React.createElement("em", null, option.price)), React.createElement("div", null, React.createElement("div", null, React.createElement("em", null, option.name)), React.createElement("div", {
      className: "grey-text"
    }, option.estimated_delivery, option.service && React.createElement(React.Fragment, null, option.service)), option.conditions && React.createElement("div", null, React.createElement("span", {
      className: "glyph glyph-small glyph-tag-red"
    }), React.createElement("span", null, option.conditions))));
  })), extraShipping.returns_method && React.createElement("section", null, React.createElement("h2", null, "Returns Policy"), React.createElement("p", {
    className: "mt10"
  }, gettext("in_stock_product.return_by_retailer", {
    retailer_name: extraShipping.retailer_name
  })), React.createElement("p", {
    className: "mb5"
  }, "Return Period: ", " ", React.createElement("em", null, extraShipping.returns_period)), React.createElement("p", {
    className: "mb5 mt5"
  }, "Cost: ", " ", React.createElement("em", null, extraShipping.returns_price)), React.createElement("p", {
    className: "mb5 mt5"
  }, "Method: ", " ", React.createElement("em", null, extraShipping.returns_method))), React.createElement("div", {
    className: style.linkHolder
  }, React.createElement(LeadLink, {
    reason: "retailer-link",
    href: leadUrl
  }, React.createElement("span", {
    dangerouslySetInnerHTML: seeMoreOnRetailerSafeHtml
  })), React.createElement(SVGIcon, {
    name: "round-chevron"
  })));
}

export default Shipping;
Shipping.propTypes = {
  className: PropTypes.string,
  expressShipping: ShippingOptionPropType,
  freeReturn: PropTypes.bool,
  freeShipping: ShippingOptionPropType,
  freeShippingUrl: PropTypes.string,
  leadUrl: PropTypes.string,
  retailerName: PropTypes.string,
  linkId: PropTypes.string
};
Shipping.defaultProps = {
  expressShipping: null,
  freeReturn: false,
  freeShipping: null
};